module.exports = __webpack_public_path__ + "img/card-medicalplan.11f33020.svg";